// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__bYqvl","list":"PatternAutocomplete_list__3rfAM"};